export const aiCommands = {
	CREATE: 'create',
	UPDATE: 'update',
	LOCK: 'lock',
	UNLOCK: 'unlock',
	DELETE: 'delete',
}
